import type {
  SortDirection,
  SortingQueryParams,
} from 'walden-fast/types/pagination';

export const sortArrayByKeyAndDirection = <Item>(
  items: Item[],
  opts: { sortKey?: string; sortDirection?: SortDirection } | undefined,
) => {
  const itemsCopy = [...items];
  if (
    opts &&
    opts.sortKey &&
    opts.sortDirection &&
    opts.sortDirection !== 'none'
  ) {
    const { sortKey, sortDirection } = opts;
    itemsCopy.sort((a, b) => {
      // @ts-expect-error this needs to be generic, no real clean way to type this and not worth hassle
      if (a[`${sortKey}`] < b[`${sortKey}`]) {
        return sortDirection === 'asc' ? -1 : 1;
      }
      // @ts-expect-error this needs to be generic, no real clean way to type this and not worth hassle
      if (a[`${sortKey}`] > b[`${sortKey}`]) {
        return sortDirection === 'asc' ? 1 : -1;
      }
      return 0;
    });
  }
  return itemsCopy;
};

export const getSortingParams = (
  params: SortingQueryParams,
): { sortField: string; sortDirection: string } | object => {
  const hasSorting = params.sortField && params.sortDirection;

  return hasSorting
    ? {
        sortField: params.sortField as string,
        sortDirection: params.sortDirection as string,
      }
    : {};
};

export const sortByRequestParams = <Item>(items: Item[], request: Request) => {
  const url = new URL(request.url);
  const sortField = url.searchParams.get('sortField') as string;
  const sortDirection = url.searchParams.get('sortDirection') as SortDirection;

  return sortArrayByKeyAndDirection<Item>(items, {
    sortKey: sortField,
    sortDirection,
  });
};
